import { Box, Typography } from "@mui/material";
import {
    MovementKpiCards,
    ProgrammeFinancialTrends,
    VariationsImpact,
    ProjectForecastMovements
} from "../components";

export const TrendsForecast = () => {
    return (
        <Box py={2}>
            <Box display="flex" flexDirection="column" alignItems="start" px={2} mb={2}>
                <Typography variant="subtitle1" color="text.primary">
                    Trends & Forecasts
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    Historical trends and forecast movements analysis
                </Typography>
            </Box>

            <MovementKpiCards />
            <ProgrammeFinancialTrends />
            <VariationsImpact />
            <ProjectForecastMovements />
        </Box>
    );
};